import * as url from "./url_helpter";
import { APIClient } from "./api_helper";

const api = new APIClient();

export const signUp = (data) => api.create(url.SIGNUP, data);
export const postJwtLogin = (data) => api.create(url.POST_LOGIN, data);
export const googleLogin = (data) => api.create(url.GOOGLE_LOGIN, data);
export const forgotPassword = (data) => api.create(url.FORGOT_PASSWORD, data);
export const verifyOtp = (data) => api.create(url.OTP, data);
export const resetPassword = (data) => api.create(url.RESET_PASSWORD, data);
export const changePassword = (data) => api.create(url.CHANGE_PASSWORD, data);
export const updateProfile = (data) => api.update(url.UPDATE_PROFILE, data);
export const unsubscribeSubscription = () =>
  api.patch(url.UNSUBSCRIBE_SUBSCRIPTION, {});
export const getUserById = (userId) => api.get(url.USER_DETAIL(userId));
export const uploadFile = (formData, header) =>
  api.create(url.UPLOAD_FILE, formData, header);
export const uploadFiles = (formData, header) =>
  api.create(url.UPLOAD_FILES, formData, header);
export const getBooks = (params) => api.get(url.BOOKS, params);
export const getBook = (bookId) => api.get(`${url.BOOKS}/${bookId}`);
export const getBlogs = (params) => api.get(url.BLOGS, params);
export const getBlog = (blogId) => api.get(`${url.BLOGS}/${blogId}`);
export const getSavedBooks = () => api.get(url.SAVES);
export const saveBookApi = (bookId) => api.create(url.SAVES, { bookId });
export const unsaveBookApi = (bookId) => api.delete(url.SAVE_DETAIL(bookId));
export const startReadingApi = (bookId) => api.create(url.READINGS, { bookId });
export const removeReadingApi = (bookId) => api.delete(url.READING_DETAIL(bookId));
export const getEvents = (params) => api.get(url.EVENTS, params);
export const getEvent = (eventId) => api.get(`${url.EVENTS}/${eventId}`);
export const getSubscriptionPlans = (params) => api.get(url.SUBSCRIPTION_PLANS, params);
export const getSubscriptionPlan = (planId) => api.get(`${url.SUBSCRIPTION_PLANS}/${planId}`);
export const createContact = (data) => api.create(url.CONTACT, data);
export const getPrivacyPolicy = () => api.get(url.PRIVACY_POLICY);
export const getRefundPolicy = () => api.get(url.REFUND_POLICY);
export const getTermsAndConditions = () => api.get(url.TERMS_AND_CONDITIONS);
export const getShippingInfo = () => api.get(url.SHIPPING_INFO);
export const createOrder = (data) => api.create(url.ORDERS, data);
export const createRapidGatewayCheckout = (data) =>
  api.create(url.RAPID_GATEWAY_CHECKOUT, data);
export const getPaymentById = (paymentId) => api.get(url.PAYMENT_DETAIL(paymentId));
export const confirmRapidGatewayReturn = (paymentId, data) =>
  api.create(url.RAPID_GATEWAY_RETURN(paymentId), data);
export const simulateRapidGatewayWebhook = (paymentId, data) =>
  api.create(url.RAPID_GATEWAY_LOCAL_WEBHOOK(paymentId), data);
export const subscribeAnnouncementTopic = (data) =>
  api.create(url.SUBSCRIBE_ANNOUNCEMENT_TOPIC, data);
export const unsubscribeAnnouncementTopic = (data) =>
  api.create(url.UNSUBSCRIBE_ANNOUNCEMENT_TOPIC, data);
